import { Card, Skeleton } from '~/components/ui';

/** A `StatTile` while its query loads; owns the loading announcement (DESIGN.md §11.1). */
export function StatTileSkeleton() {
  return (
    <Card className="p-5">
      <div role="status" aria-busy="true">
        <span className="sr-only">Loading…</span>
        <Skeleton className="h-3 w-24" />
        <Skeleton className="mt-3 h-8 w-16" />
      </div>
    </Card>
  );
}
